import React from 'react';
import PropTypes from 'prop-types';
import CodeInput from 'react-code-input';
import classNames from 'classnames';
import FormFeedback from './FormFeedback';
import './WrappedCodeInput.css';

function WrappedCodeInput(props) {
  return (
    <React.Fragment>
      <CodeInput
        {...props}
        className={classNames('form-code-input', {
          'form-code-input--accept': props.accept,
          'form-code-input--reject': props.reject
        })}
        value={props.input.value}
        onChange={value => props.input.onChange(value)}
      />
      {props.meta.error && (
        <div className="diary-lock__incorrect-message">
          <FormFeedback positive={false}>{props.meta.error}</FormFeedback>
        </div>
      )}
    </React.Fragment>
  );
}
WrappedCodeInput.defaultProps = {
  accept: false,
  reject: false,
  disabled: false,
  error: null,
  type: null,
  autoFocus: false
};

WrappedCodeInput.propTypes = {
  accept: PropTypes.bool,
  reject: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.shape({
        value: PropTypes.any,
        label: PropTypes.string
      }),
      PropTypes.any
    ]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string
  }).isRequired
};

export default WrappedCodeInput;



// WEBPACK FOOTER //
// ./src/components/form/WrappedCodeInput.js